import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11.414,
	height: 11.414,
	viewBox: "0 0 11.414 11.414",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.707 0.707)",
			children: [/* @__PURE__ */ _jsx("line", {
				className: "a",
				x2: 10,
				y2: 10
			}), /* @__PURE__ */ _jsx("line", {
				className: "a",
				x1: 10,
				y2: 10
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgCloseSmall);
export { ForwardRef as ReactComponent };
